export default {
    bruto: 'Bruto',
    formatado: 'Formateado',
    copiar: 'Copiar',
    copiado_sucesso: '¡Contenido copiado con éxito!'
}